import { Injectable } from "@angular/core";
import { BasePrimaryActionService } from "./BasePrimaryActionService";
import { ServiceMessageBroker, ServiceMessageBrokerFactory } from "shared/provider-webworker";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { CubiqWorker } from "shared/cubiq-services/worker/CubiqWorker";
import { NotificationService } from "shared/cubiq-services/lookup/notification/impl/NotificationService";
import { BFXNotificationType } from "shared/cubiq-services/model/core/notifications/BFXNotificationType";
import { BFXNotificationSubType } from "shared/cubiq-services/model/core/notifications//BFXNotificationSubType";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

export const MANUAL_PRICE_ACTION_CHANNEL: string = "ManualPriceActionChannel";

@Injectable()
export class ManualPriceActionPrimaryService extends BasePrimaryActionService {
  protected broker: ServiceMessageBroker;

  constructor(
    private worker: CubiqWorker,
    protected factory: ServiceMessageBrokerFactory,
    //private sysConfigService: SystemConfigPromiseService,
    private notification: NotificationService,
  ) {
    super();
    this.broker = factory.createMessageBroker(MANUAL_PRICE_ACTION_CHANNEL, true, true);
  }

  public issueManualPriceLock(requirementIds: Array<string>): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (Array.isArray(requirementIds) && requirementIds.length > 0) {
        if (typeof requirementIds[0] === "string") {
          let request = new CubiqTS.FixingRateRequirementLockRequestImpl();
          request.requirementIds = requirementIds;
          this.worker.postServiceRequest(request).then((response) => {
            this.notification.handleErrors(
              response,
              BFXNotificationType.ORDER_ACTION_FAIL,
              BFXNotificationSubType.UNLOCK_FAIL,
            );
            resolve(response);
          });
        } else {
          reject(
            "Manual-Price-Action: [LOCK]: Invalid input parameter type (requirementIds: Array<string>)",
          );
        }
      } else {
        reject(
          "Manual-Price-Action: [LOCK]: Missing input parameter (requirementIds: Array<string>)",
        );
      }
    });
  }

  public issueManualPriceUnlock(requirementIds: Array<string>): Promise<any> {
    //logger.out.warn('issueManualPriceUNLock() Issued =', requirementIds);
    return new Promise<any>((resolve, reject) => {
      if (Array.isArray(requirementIds) && requirementIds.length > 0) {
        if (typeof requirementIds[0] === "string") {
          // type check
          let request = new CubiqTS.FixingRateRequirementUnlockRequestImpl();
          request.requirementIds = requirementIds;
          this.worker.postServiceRequest(request).then((response) => {
            this.notification.handleErrors(
              response,
              BFXNotificationType.ORDER_ACTION_FAIL,
              BFXNotificationSubType.UNLOCK_FAIL,
            );
            resolve(response);
          });
        } else {
          reject(
            "Manual-Price-Action: [UNLOCK]: Invalid input parameter type (requirementIds: Array<string>)",
          );
        }
      } else {
        reject(
          "Manual-Price-Action: [UNLOCK]: Missing input parameter (requirementIds: Array<string>)",
        );
      }
    });
  }

  public issueManualPrice(fixingPrices: Array<CubiqTS.ManualPriceImpl>): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (Array.isArray(fixingPrices) && fixingPrices.length > 0) {
        if (fixingPrices[0] instanceof CubiqTS.ManualPriceImpl) {
          let request = new CubiqTS.FixingPriceRequestImpl();
          request.manualPrices = fixingPrices;
          this.worker.postServiceRequest(request).then((response) => {
            if (response instanceof CubiqTS.StandardReportImpl) {
              this.notification.handleErrors(
                response,
                BFXNotificationType.INTERVENTION_ACTION_FAIL,
                BFXNotificationSubType.MANUAL_PRICE_FAIL,
              );
              resolve(response);
              // added for OMS-32081 but superseded by OMS-32164
              /*if(Array.isArray(response.results) && response.results.length > 0){
							
								 let failedPriceDataset = response.results.filter((item)=> {
									 return item instanceof CubiqTS.ManualPriceImpl &&
										item.errors instanceof CubiqTS.ErrorsImpl &&
										Array.isArray(item.errors.errorMessages) &&
										item.errors.errorMessages.length > 0;
								});
								if(Array.isArray(failedPriceDataset) && failedPriceDataset.length > 0){
									let toBeUnlocked = failedPriceDataset.map((item: CubiqTS.ManualPriceImpl) => item.requirementId.toString());
									this.issueManualPriceUnlock(toBeUnlocked);
								}
							}else{
								reject('Manual-Price-Action: [PRICE]: Missing response results -> expected = Array<ManualPriceImpl>');
							} */
            } else {
              reject(
                "Manual-Price-Action: [PRICE]: Invalid response type -> expected = StandardReportImpl",
              );
            }
          });
        } else {
          reject(
            "Manual-Price-Action: [PRICE]: Invalid input parameter type -> required = Array<ManualPriceImpl> ",
          );
        }
      } else {
        reject(
          "Manual-Price-Action: [PRICE]: Missing input parameter -> required = Array<ManualPriceImpl>",
        );
      }
    });
  }
}
